const formEquipmentsLogs = {
  actionsNotFound: 'Nenhum log encontrado'
};

export default formEquipmentsLogs;
